import { render, staticRenderFns } from "./materialControl.vue?vue&type=template&id=41d00752&scoped=true&"
import script from "./materialControl.vue?vue&type=script&lang=js&"
export * from "./materialControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d00752",
  null
  
)

export default component.exports